import { render, staticRenderFns } from "./TrafficFineCreateOrUpdate.vue?vue&type=template&id=6c102b14&"
import script from "./TrafficFineCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./TrafficFineCreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TrafficFineCreateOrUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports